import React from 'react';
import './styles.css';

const AboutModal = ({ onClose }) => {
  const currentYear = new Date().getFullYear();
  const buildNumber = process.env.REACT_APP_BUILD_NUMBER;
  const env = process.env.REACT_APP_SL8_ENV;

  return (
    <div className="about-modal" data-theme="dark">
      {onClose && (
        <button
          className="about-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <i className="material-symbols-outlined" style={{ fontSize: 20 }}>close</i>
        </button>
      )}
      <div className="about-modal-brand">
        <img
          src="/images/Login-SL8-Logo@2x.png"
          alt="Slate Pages"
          className="about-modal-logo"
        />
      </div>

      <div className="about-modal-meta">
        <span className="about-modal-version">v2.5</span>
        <span className="about-modal-separator" />
        <span className="about-modal-build">Build: {buildNumber}</span>
        {env && env !== 'production' && (
          <>
            <span className="about-modal-separator" />
            <span className={`about-modal-env about-modal-env--${env}`}>
              {env}
            </span>
          </>
        )}
      </div>

      <div className="about-modal-footer">
        <div className="about-modal-copyright">
          &copy; {currentYear} The Slate Pages, LLC
        </div>
        <div className="about-modal-links">
          <a
            href="https://slatepages.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Website
          </a>
          <a
            href="https://slatepages.com/terms-of-use/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms
          </a>
          <a
            href="https://slatepages.com/terms-of-use/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
